// role-based color constants for consistent theming based on user type
export const ROLE_COLORS = {
  donor: {
    primary: "#669d2e",
    primaryRgb: "102, 157, 46",
    hoverLight: "rgba(102, 157, 46, 0.08)",
    hoverDark: "rgba(102, 157, 46, 0.15)",
    activeLight: "rgba(102, 157, 46, 0.18)",
    activeHover: "rgba(102, 157, 46, 0.22)",
    accentLight: "#e8f5e9",
    accentDark: "#4a7020",
  },
  receiver: {
    primary: "#2196F3",
    primaryRgb: "33, 150, 243",
    hoverLight: "rgba(33, 150, 243, 0.08)",
    hoverDark: "rgba(33, 150, 243, 0.15)",
    activeLight: "rgba(33, 150, 243, 0.18)",
    activeHover: "rgba(33, 150, 243, 0.22)",
    accentLight: "#E3F2FD",
    accentDark: "#1565C0",
  },
  both: {
    primary: "#0d9488",
    primaryRgb: "13, 148, 136",
    hoverLight: "rgba(13, 148, 136, 0.08)",
    hoverDark: "rgba(13, 148, 136, 0.15)",
    activeLight: "rgba(13, 148, 136, 0.18)",
    activeHover: "rgba(13, 148, 136, 0.22)",
    accentLight: "#ccfbf1",
    accentDark: "#0f766e",
  },
};

export const ROLES = {
  DONOR: "donor",
  RECEIVER: "receiver",
  BOTH: "both",
};